import { useEffect } from 'react';
import type React from 'react';

import { Link } from '@change/ds-core-ui';
import { Form } from '@change/ds-forms';

import { Translate } from '@change-corgi/core-react/i18n';

import { PasswordInput } from '../PasswordInput';

import { useLoginStep } from './hooks/useLoginStep';

export const LoginStep: React.FC = () => {
	const {
		data: { password, passwordError, showOtpLink },
		actions: { setStepData, submitStep, trackStepView, sendResetPasswordLink, gotoOtpStep },
	} = useLoginStep();

	useEffect(() => {
		trackStepView();
	}, [trackStepView]);

	return (
		<div>
			<Form
				onSubmit={() => {
					void submitStep();
				}}
				data-testid="forgot-password-form"
				data-qa="forgot-password-form"
			>
				<PasswordInput onChange={(value) => setStepData({ password: value })} value={password} error={passwordError} />
			</Form>
			<div className="mt-2">
				<Link
					as="button"
					variant="secondary"
					onClick={sendResetPasswordLink}
					data-testid="forgot-password"
					data-qa="forgot-password"
				>
					<Translate value="corgi.login_or_signup.common.labels.forgot_password" />
				</Link>
			</div>
			{showOtpLink && (
				<div className="mt-7">
					<Link
						as="button"
						variant="secondary"
						onClick={gotoOtpStep}
						data-testid="send-code-instead"
						data-qa="send-code-instead"
					>
						<Translate value="corgi.login_or_signup.login_password.send_code_instead" />
					</Link>
				</div>
			)}
		</div>
	);
};
